import './App.css'
import { AuthProvider } from './common/components/auth/AuthProvider'
import AuthWrapper from './common/components/auth/LoadingAuthData'
import { ToastProvider } from './common/components/ui/toast/toast.provider'
import Routes from './routes'


function App() {
  
  return (
    <ToastProvider>
      <AuthWrapper>
        <AuthProvider>
            <Routes />
       </AuthProvider>
      </AuthWrapper >
    </ToastProvider>
  )
}

export default App
